import { appStore } from 'src/mobx/appStore';
import { IProduct } from 'src/types/products';

const isLatinWithSpaces = (word: string) => /^[a-zA-Z0-9\s]+$/.test(word);

const toSnakeCase = (str: string) => str.toLowerCase().replace(/[^a-z0-9]+/g, '_');

export function parseProductUrl(product: IProduct) {
  if (product) {
    const productName = product.name?.en;
    const productId = product.id;
    if (!appStore.settings?.is_human_readable_url || !productName || !isLatinWithSpaces(productName)) {
      return productId;
    }
    const newUrl = toSnakeCase(productName) + `_${productId}`;
    return newUrl;
  }
  return '';
}

export function getIdFromUrl(url: string) {
  if (Number(url)) return url;
  const indexOfId = url.lastIndexOf('_');
  return url.substring(indexOfId + 1);
}
